/**
 * 验收/整改时间轴展示规则：
 * 1. 若某次验收结果为「不合格」，在其后、下一次整改记录出现之前的验收记录不展示（避免无效占位验收块）。
 * 2.（可选）若某次验收结果为「不合格」，紧随其后的那一条整改记录也不展示。
 *    台账已通过（status=4）时应传 omitRectifyAfterReject: false，以保留完整历史。
 */

function recordType (rec) {
  const t = rec && rec.type
  if (t === 1 || t === '1' || t === 'rectify') return 'rectify'
  if (t === 2 || t === '2' || t === 'accept') return 'accept'
}

/**
 * @param {Array} records 已按轮次、类型排好序的列表（与 sortedAcceptanceHistory 一致）
 * @param {{ omitRectifyAfterReject?: boolean }} [opts]
 * @returns {Array}
 */
export function filterAcceptHistoryAfterReject (records, opts = {}) {
  const omitRectifyAfterReject = opts.omitRectifyAfterReject !== false
  if (!Array.isArray(records) || !records.length) return []
  let suppressAccept = false
  let suppressNextRectify = false
  const out = []
  for (const rec of records) {
    const rt = recordType(rec)
    if (rt === 'rectify') {
      if (omitRectifyAfterReject && suppressNextRectify) {
        suppressNextRectify = false
        suppressAccept = false
        continue
      }
      suppressAccept = false
      out.push(rec)
      continue
    }
    if (rt === 'accept') {
      if (suppressAccept) continue
      out.push(rec)
      if (Number(rec.acceptanceResult) === 2) {
        suppressAccept = true
        if (omitRectifyAfterReject) suppressNextRectify = true
      }
      continue
    }
    out.push(rec)
  }
  return out
}
